import React, { useState, useEffect, useCallback } from "react";
import {
  Show,
  List,
  Button,
  Link,
  TabbedShowLayout,
  Tab,
  Filter,
  TextInput,
  TextField,
  BooleanField,
  TopToolbar,
  RefreshButton,
  ListButton,
  EditButton,
  ReferenceManyField,
  DateField,
  Datagrid,
  ReferenceField,
  GET_ONE,
  useRecordContext,
  usePermissions,
  useResourceContext,
  useGetOne,
  useTranslate,
  ShowButton,
} from "react-admin";
import Swal from "sweetalert2";

import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import { getLocalStorageKey } from "../common/common";
import Modal from "react-responsive-modal";
import FormattedCurrencyNumberCustom from "../formatted-currency-number-custom";
import Spinner from "../../src/spinner";
import { CommonHeaderOption } from "../common/common";
import myDataProvider from "../myRestProvider";
import { useLocation } from "react-router-dom";
import { RUN_TIME_API_ENDPOINT } from "../common/common";
import { useNavigate } from "react-router-dom";

const apiUrl = RUN_TIME_API_ENDPOINT;

// const cardActionStyle = {
//   zIndex: 2,
//   display: 'inline-block',
//   float: 'right',
// };

class ExampleApp extends React.Component {
  constructor(props) {
    super(props);
    this.fetchItem(props.id);
    this.reload = this.reload.bind(this);
    this.state = {
      open: false,
      showloader: true,
      reloadButton: false,
      data: {},
      dateFlag: false,
      showModalForZambiaTanzania: false,
      showModalForOtherCountries: false,
    };
    // console.log("permission123", props);
    console.log("id is", props.id);
  }

  componentDidMount() {
    const { props } = this;
    if (props.permissions === "isJDE") {
      this.setState({
        showModalForZambiaTanzania: true,
      });
    } else {
      this.setState({
        showModalForOtherCountries: true,
      });
    }
  }

  onOpenModal = () => {
    console.log(this.props);
    this.setState({ open: true, reloadButton: false });
    this.fetchItem(this.props.id);
    // if (this.state.showModalForOtherCountries) {
    // } else {
    //     this.fetchItemForJDE(this.props.record._links.self.href);
    // }
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };
  render() {
    const { open } = this.state;
    return (
      <div className="detailsBtn">
        {!open ? (
          <p onClick={this.onOpenModal}>Check balance</p>
        ) : (
          <Modal open={open} onClose={this.onCloseModal} center>
            <table>
              {this.state.showModalForZambiaTanzania && (
                <div>
                  <tr>
                    <th>Payment term</th>
                    <th>OutStanding Payments</th>
                    <th>Credit Limit</th>
                    <th>Paid-In Amount</th>
                    <th>Credited Amounts</th>
                    <th>Invoiced Amounts</th>
                    <th>Open Orders Amount</th>
                    <th>Amount owed between 1-30 days</th>
                    <th>Over 30 days</th>
                    <th>Available Balance</th>
                  </tr>
                  <tr>
                    <td>
                      {this.state.data.payment_terms
                        ? this.state.data.payment_terms
                        : ""}
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.outstanding_payments
                            ? this.state.data.outstanding_payments
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.credit_limit
                            ? this.state.data.credit_limit
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.paid_in_amount
                            ? this.state.data.paid_in_amount
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.credited_amounts
                            ? this.state.data.credited_amounts
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.invoiced_amount_not_yet_paid
                            ? this.state.data.invoiced_amount_not_yet_paid
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.orders_not_invoiced_price
                            ? this.state.data.orders_not_invoiced_price
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.current_and_1_to_30_days
                            ? this.state.data.current_and_1_to_30_days
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.over_30_days
                            ? this.state.data.over_30_days
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.sap_digital_order_balance
                            ? this.state.data.sap_digital_order_balance
                            : 0
                        }
                      />
                    </td>
                  </tr>
                </div>
              )}
              {this.state.showModalForOtherCountries && (
                <div>
                  <tr>
                    <th>SAP credit area Cd</th>
                    <th>Last SAP update</th>
                    <th>Currency</th>
                    <th>Credit limit</th>
                    <th>Credit exposure SAP</th>
                    <th>Credit exposure LOGON</th>
                    <th>Open credit LOGON</th>
                    <th>Orders not invoiced price</th>
                    <th>Digital order balance</th>
                  </tr>
                  <tr>
                    <td>
                      {this.state.data.sap_credit_area_cd
                        ? this.state.data.sap_credit_area_cd
                        : ""}
                    </td>
                    <td>
                      {this.state.dateFlag && this.state.data.last_sap_update}
                    </td>
                    <td>
                      {this.state.data.currency ? this.state.data.currency : ""}
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.credit_limit
                            ? this.state.data.credit_limit
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.credit_exposure_sap
                            ? this.state.data.credit_exposure_sap
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.credit_exposure_logon
                            ? this.state.data.credit_exposure_logon
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.open_credit_logon
                            ? this.state.data.open_credit_logon
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.orders_not_invoiced_price
                            ? this.state.data.orders_not_invoiced_price
                            : 0
                        }
                      />
                    </td>
                    <td>
                      <FormattedCurrencyNumberCustom
                        value={
                          this.state.data.sap_digital_order_balance
                            ? this.state.data.sap_digital_order_balance
                            : 0
                        }
                      />
                    </td>
                  </tr>
                </div>
              )}
              <tr className="errorMsg">
                <td colspan="9">
                  {this.state.reloadButton && (
                    <div>{this.state.data.msgText}</div>
                  )}
                </td>
              </tr>
              <tr>
                <td className="spinner" colspan="9">
                  <div className="spinner">
                    {this.state.showloader && window.navigator.onLine && (
                      <Spinner />
                    )}
                  </div>
                  {this.state.reloadButton && (
                    <div className="refresh">
                      <i onClick={this.reload} class="material-icons">
                        refresh
                      </i>
                    </div>
                  )}
                  <div>
                    {!window.navigator.onLine && (
                      <p>
                        It seems that you are offline. Please check your
                        internet connection
                      </p>
                    )}
                  </div>
                </td>
              </tr>
            </table>
          </Modal>
        )}
      </div>
    );
  }
  reload() {
    this.setState(
      {
        reloadButton: false,
        showloader: true,
      },
      () => this.fetchItem(this.props.id)
    );
  }

  fetchItem = async (id) => {
    this.setState({ showloader: true, data: {} }, async () => {
      const json = await myDataProvider(GET_ONE, "getSapDetails", { id });
      console.log("json", json);
      const item = json.data;
      var countryTime = new Date(item && item.last_sap_update).toLocaleString(
        "en-US"
      );
      console.log("countryTime", countryTime);
      this.setState({
        showloader: false,
        data: {
          ...item,
          last_sap_update: countryTime,
        },
        reloadButton: item && item.errorMsg === "Reload",
        dateFlag: countryTime !== "Invalid Date",
      });
    });
  };
}

const BusinessesFilter = (props) => (
  <Filter {...props}>
    <TextInput source="name" />
    {/* <TextInput source="phone" defaultValue="" /> */}
    <TextInput source="sap_code" 
    // label="Sold To ID"
     defaultValue="" />
    {/* <SelectInput
      source="is_ordering_blocked"
      label="Ordering Blocked"
      choices={[
        { id: true, name: "True" },
        { id: false, name: "False" },
      ]}
    /> */}
  </Filter>
);

const CreateUser = ({ data, resource }) => {
  console.log("record", data, resource);
  const translate = useTranslate();

  return (
    <Button
      className="custom-button create-sdo"
      component={Link}
      to={{
        pathname: `/users/create`,
        state: data && data.id,
      }}
    >
      <span>+ {translate("resources.businesses.fields.create_user")}</span>
    </Button>
  );
};

const ShowActions = () => {
  const location = useLocation();
  const permissions = usePermissions();
  const resource = useResourceContext();
  const localStorageLocale = getLocalStorageKey("locale");
  const record = useRecordContext();
  localStorage.setItem("businessID", record?.id);
  // console.log("business record", record);
  const { data } = useGetOne("businesses", { id: record?.id });

  return (
    <TopToolbar className="toolbar-center-align">
      <CreateUser data={data} resource={resource} />
      <RefreshButton />
      <ListButton />
      {(permissions === "isManual" ||
        permissions === "isJDE" ||
        permissions === "isSageAPI" ||
        localStorageLocale === "en-GB"
        ) && <EditButton record={data} />}
    </TopToolbar>
  );
};

const ShowTitle = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <span>{record ? `${record?.name} ` : ""}</span>;
};

const ShowUserFullName = () => {
  const record = useRecordContext();
  return (
    <span>
      {/* {`${moment(record[source]).format('MM/DD/YYYY')} - ${moment(record[source]).add(2, 'days').format('MM/DD/YYYY')}`} */}
      {`${record.first_name} ${record.last_name}`}
    </span>
  );
};

const ListingModal = (props) => {
  const location = useLocation();
  const recordStatus = useRecordContext();
  const [openModal, setOpen] = useState(false);
  const [userId, setUserId] = useState(1);
  const [recordValue, setRecordValue] = useState("");

  // let recordValue = recordStatus.status ? "ON" : "OFF";

  useEffect(() => {
    // Update the document title using the browser API
    setRecordValue(recordStatus.status ? "ON" : "OFF");
    let _paramsUrl = location.pathname.split("/");
    console.log("_paramsUrl", _paramsUrl);

    if (_paramsUrl.length > 1 && _paramsUrl[2] !== "") {
      console.log("params found", _paramsUrl[2]);
      setUserId(_paramsUrl[2]);
    }
  }, []);

  const onSave = async (recordStatus) => {
    const url = `${apiUrl}/contract_status_update`;
    const data = {
      status: !recordStatus?.status,
      business_id: Number(userId),
      contract_number: recordStatus.contract_number,
      id: recordStatus.id,
      type: props.type
    };
    const options = CommonHeaderOption();
    options.method = "PATCH";
    options.body = JSON.stringify(data);
    Swal.fire({
      text: "Please wait while your request is being processed.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const res = await fetch(url, options);
      if (res.status === 401) {
        localStorage.removeItem("__state");
        window.location.href = "#/login";
      }
      const json = await res.json();
      console.log("json ===>", json);
      window.location.reload();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Unable to process your request at this time. Please try again later.",
      });
      console.log(error);
    }
  };

  const openListingModal = useCallback(() => {
    if (recordValue === "ON") {
      console.log("recordStatusss => ", recordStatus.status);
      setOpen(true);
    } else {
      console.log("recordStatusss ONN => ", recordValue);
      let _paramsUrl = window.location.href.split("?");
      if (_paramsUrl.length > 1 && _paramsUrl[1] !== "") {
        console.log("params found", _paramsUrl);
      }
      setOpen(true);
    }
  }, [recordValue]);

  const onCloseModal = () => {
    setOpen(true);
  };

  const onToggle = () => {
    console.log("statuscccc", recordStatus);
    let settingValue = recordValue === "ON" ? "OFF" : "ON";
    Swal.fire({
      text:
        "Are you sure to change the value of " +
        recordValue +
        " to " +
        settingValue +
        ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        onSave(recordStatus);
      }
    });
  };

  return (
    <div>
      <div
        className={`toggle-button-container ${
          recordValue === "ON" ? "toggle-button-on" : ""
        }`}
      >
        <label className="switch">
          <input
            type="checkbox"
            checked={recordValue === "ON"}
            onChange={openListingModal}
          />{" "}
          <div></div>
        </label>
        <span className="switch-status">{recordValue}</span>
      </div>
      {openModal && onToggle()}
    </div>
  );
};

const BusinessesShow = () => {
  const permissions = usePermissions();
  const record = useRecordContext();
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  let businessIdVal = pathSplit[2];
  const showAllOrders = getLocalStorageKey("show_all_orders");
  const localStorageLocale = getLocalStorageKey("locale");
  const translate = useTranslate();
  const { navigate } = useNavigate();
  const localStorageAppType = getLocalStorageKey("app_type");
  const [baseThemeColor, setBaseThemeColor] = useState("clickittheme");
  const isHolcim = localStorageAppType === "HOLCIM";

  useEffect(() => {
    if (localStorageAppType === "HOLCIM") {
      setBaseThemeColor("holcimtheme");
    } else {
      setBaseThemeColor("clickittheme");
    }
  }, [localStorageAppType]);

  const CustomShowButton = (props) => {
    const record = useRecordContext();
    const resource = useResourceContext();
    localStorage.setItem("projectId", record?.project_id);
    return (
      // <div>
      //   <ShowButton
      //     resource={resource}
      //     record={{ id: record?.id + "-" + record?.project_id + "-" + props?.type }}
      //   />
      // </div>

      <ShowButton
        resource={resource}
        record={{ id: `${record?.id}-${record?.project_id}-${props?.type}` }}
        component={Link}
        to={{
            pathname: `/${resource}/${record?.id}-${record?.project_id}-${props?.type}/show`,
            state: {
                project_title: record?.project_title,
                project_number: record?.project_number,
            },
        }}
      />
    );
  };

  return (
    <Show actions={<ShowActions />} title={<ShowTitle />}>
      <TabbedShowLayout className="tab-scroll">
        <Tab
          label={translate("resources.businesses.fields.profile_details")}
          source="profile_details"
          contentClassName="scrollTab"
        >
          {/* <ImageField
            source="profile_data_url"
            title="Profile Image"
            label="Profile"
          /> */}
          {/* <TextField source="phone" /> */}
          <TextField source="name" />
          <TextField 
          // label="Sold To ID" 
          source="sap_code" />
          <TextField label={isHolcim ? "Holcim+ Users" : "Clickit Users"} source={"users_count"}
          // label="Clickit Users" 
          />
          {
            localStorageLocale == "en-GB" &&
            <TextField source="contract_count" 
            />
          }
          // label="Contracts"
          {/* <TextField source="email" /> */}
          {/* <TextField source="address" /> */}
          {/* {(permissions === "isSap" || permissions === "isJDE") && (
            <ExampleApp id={props.id} permissions={permissions} />
          )} */}
          {/* <TextField source="total_credit_cents" label="My Store credit" /> */}
          {/* <TextField source="contact_person" /> */}
          {/* <TextField source="sap_digital_order_balance" /> */}
          {/* <TextField source="orders_not_invoiced_price" /> */}
          {/* <BooleanField source="is_sap_blocked" /> */}
          {/* <BooleanField source="is_sap_deleted" /> */}
          <BooleanField source="is_ordering_blocked" />
          <TextField source="cement_system" />
        </Tab>

        {/* <Tab label="Contracts">
          <ReferenceManyField
            addLabel={false}
            sort={{ field: "created_at", order: "DESC" }}
            reference="sap_contracts"
            source="id"
            target="business_id"
            className="tab-pagination"
          >
            <List
              {...props}
              sort={{ field: "created_at", order: "DESC" }}
              filterDefaultValues={{ business_id: props.id }}
              bulkActionButtons={false}
              exporter={false}
            >
              <Datagrid rowClick="show">
                <TextField source="contract_number" />
                <TextField source="contract_type" />
                <TextField
                  source="retailer_info.sap_code"
                  label="Sold To ID"
                  sortable={false}
                />
                <DateField
                  label="Contract Valid From"
                  source="contract_valid_from"
                />
                <DateField
                  label="Contract Valid To"
                  source="contract_valid_to"
                />
                <TextField source="inco_term" />
                <DateField
                  label="Created at"
                  source="created_at"
                  sortable={false}
                />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab> */}
        <Tab label={translate("resources.businesses.fields.orders")}>
          <ReferenceManyField
            label=""
            sort={{ field: "created_at", order: "DESC" }}
            reference={
              showAllOrders ? "sap_digital_orders" : "sap_digital_app_orders"
            }
            source="id"
            target="business_id"
            className="tab-pagination"
          >
            <List
              actions={false}
              className="tab-list"
              filterDefaultValues={{ business_id: businessIdVal }}
              sort={{ field: "created_at", order: "DESC" }}
              exporter={false}
              disableSyncWithLocation
            >
              <Datagrid rowClick="show" bulkActionButtons={false}>
                <DateField
                  label={"Order Date"}
                  source="creation_date"
                  showTime
                />
                <TextField source="order_number" />
                <CamelCaseField
                  source="mode_of_delivery"
                  label="Mode Of Delivery"
                />
                <ExpectedDateField
                  // label="Expected Date"
                  source="delivery_date_from"
                />
                <TextField
                  // label="Local PO Note"
                  source="customer_ref_number"
                />
                <TextField
                  label="Order Status"
                  source="customer_order_status_desc"
                />
                <ReferenceField
                  label="Ship To Name"
                  source="sap_business_site_id"
                  reference="sap_business_sites"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                {permissions === "isSap" && (
                  <DateField label="Date 1st seen in LR" source="created_at" />
                )}
                {permissions === "isSap" && showAllOrders && (
                  <TextField label="Is App Order" source="is_app_order" />
                )}
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        <Tab label={translate(baseThemeColor === 'clickittheme'? "resources.businesses.fields.clickit_user" : "resources.businesses.fields.holcim_user")}>
          <ReferenceManyField
            label=""
            sort={{ field: "created_at", order: "DESC" }}
            reference="users"
            source="id"
            target="business_id"
            className="tab-pagination"
          >
            <List
              actions={false}
              className="tab-list"
              // {...props}
              // filterDefaultValues={{ business_id: record?.id }}
              filterDefaultValues={{ business_id: businessIdVal }}
              sort={{ field: "created_at", order: "DESC" }}
              exporter={false}
              hasCreate={false}
              disableSyncWithLocation
            >
              <Datagrid bulkActionButtons={false}>
                <ShowUserFullName source="name" />
                <TextField source="phone" sortable={false} allowEmpty />
                <TextField source="email" allowEmpty />
                <TextField source="role_name" allowEmpty />
                <BooleanField source="status" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        {
          localStorageLocale == "en-GB" &&
          <Tab label={translate("cement contracts")}>
            <ReferenceManyField
              label=""
              sort={{ field: "created_at", order: "DESC" }}
              reference="business_contracts"
              source="id"
              target="business_id"
              className="tab-pagination"
            >
              <List
                className="tab-list"
                // filters={<BusinessesFilter />}
                actions={false}
                filterDefaultValues={{ business_id: businessIdVal }}
                sort={{ field: "project_title", order: "DESC" }}
                filter={{ type: "cement" }}
                exporter={false}
                disableSyncWithLocation
              >
                <Datagrid rowClick={false} bulkActionButtons={false}>
                  <TextField source="contract_number" />
                  <TextField source="project_number" />

                  <TextField source="project_title" allowEmpty />
                  <TextField source="project_address" allowEmpty />
                  <TextField source="op_division" allowEmpty />
                  {/* <TextField source="phone" sortable={false} allowEmpty /> */}
                  {/* <TextField
                    label="Sold To Name"
                    source="retailer_sapcode"
                    sortable={false}
                  /> */}
                  {/* <DateField label="Created at" source="created_at" allowEmpty /> */}
                  {/* <TextField source="status" /> */}
                  <ListingModal source="status"type="cement"/>
                  <CustomShowButton type="cement"/>
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
        }
        {
          localStorageLocale == "en-GB" &&
          <Tab label={translate("Aggregate Contracts")}>
            <ReferenceManyField
              label=""
              sort={{ field: "created_at", order: "DESC" }}
              reference="business_contracts"
              source="id"
              target="business_id"
              className="tab-pagination"
            >
              <List
                className="tab-list"
                actions={false}
                filterDefaultValues={{ business_id: businessIdVal }}
                sort={{ field: "project_title", order: "DESC" }}
                filter={{ type: "aggregate" }}
                exporter={false}
                disableSyncWithLocation
              >
                <Datagrid rowClick={false} bulkActionButtons={false}>
                  <TextField source="contract_number" />
                  <TextField source="project_number" />

                  <TextField source="project_title" allowEmpty />
                  <TextField source="project_address" allowEmpty />
                  <TextField source="op_division" allowEmpty />
                  <ListingModal source="status" type="aggregate"/>
                  <CustomShowButton type="aggregate"/>
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
        }
        {
          localStorageLocale == "en-GB" &&
          <Tab label={translate("Asphalt Contracts")}>
            <ReferenceManyField
              label=""
              sort={{ field: "created_at", order: "DESC" }}
              reference="business_contracts"
              source="id"
              target="business_id"
              className="tab-pagination"
            >
              <List
                className="tab-list"
                actions={false}
                filterDefaultValues={{ business_id: businessIdVal }}
                sort={{ field: "project_title", order: "DESC" }}
                filter={{ type: "asphalt" }}
                exporter={false}
                disableSyncWithLocation
              >
                <Datagrid rowClick={false} bulkActionButtons={false}>
                  <TextField source="contract_number" />
                  <TextField source="project_number" />

                  <TextField source="project_title" allowEmpty />
                  <TextField source="project_address" allowEmpty />
                  <TextField source="op_division" allowEmpty />
                  <ListingModal source="status" type="asphalt"/>
                  <CustomShowButton type="asphalt"/>
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
        }
      </TabbedShowLayout>
    </Show>
  );
};

export default BusinessesShow;
